<template>
  <div id="project-documents-documents">
    <p v-if="!canProjectAccess">
      {{ $t('noTabPermission') }}
    </p>
    <template v-else>
      <div class="project-documents-doc-header clearfix">
        <div class="project-documents-doc-header-font float-left">
          {{ $t('project.docs.header') }}
        </div>
        <AddDocType v-if="isProjectRepresentative || !isContractor" />
        <button
          type="button"
          :class="{'btn--darkblue': isExpand, 'btn--orange': !isExpand, 'btn': true, 'float-right': true}"
          @click="() => toggleExpandAll()"
        >
          {{ isExpand ? $t('collapseAll') : $t('expandAll') }}
        </button>
      </div>
      <div class="project-documents-doc-type">
        {{ $t('project.docs.projectFolder') }}
      </div>
      <div class="project-documents-accordion-container">
        <DocAccordion
          ref="docAccordion"
          :isContractor="isContractor"
          @docAccordionExpand="(isExpand) => setIsExpand(isExpand)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { ref } from 'vue-demi'
import { useStoreGetters } from '@/store/index'
import AddDocType from '@/modules/projects/documents/AddDocType'
import DocAccordion from '@/modules/projects/documents/DocAccordion'
import { useIsProjectRepresentative, useCanProjectAccess } from '@/pages/projects/projectInfo'

export default {
  name: 'ProjectDocuments',
  components: {
    AddDocType, DocAccordion,
  },
  setup () {
    let returnData = {}
    const { isContractor } = useStoreGetters('user', ['isContractor'])
    const isProjectRepresentative = useIsProjectRepresentative()
    const canProjectAccess = useCanProjectAccess()
    returnData = Object.assign(returnData, {
      isContractor,
      isProjectRepresentative,
      canProjectAccess,
    })
    const docAccordion = ref(null)
    const isExpand = ref(false)
    const setIsExpand = (value) => {
      isExpand.value = value
    }
    const toggleExpandAll = () => {
      const component = docAccordion.value
      if (isExpand.value) {
        component.collapseAll()
      } else {
        component.expandAll()
      }
    }
    returnData = {
      ...returnData,
      docAccordion,
      isExpand,
      setIsExpand,
      toggleExpandAll,
    }

    return returnData
  },
}
</script>

<style scoped lang="scss">

.project-documents-doc-header-font {
  padding: 0.85rem 0;
  color: #6e7a91;
}
.project-documents-doc-type {
  font-size: 24px;
  padding: 20px 0;
}

#project-documents-documents {
  background-color: #f9f9f9;
  .project-documents-doc-header {
    button {
      margin-right: 16px;
    }
  }
}
</style>
